import React, {Component} from 'react';
import Normal from './Normal';
import Retail from './Retail';

class Container extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  };

  render() {
    //console.log( this.props.data_product );
    //let is_ocu_item = false;
    //if( this.props.data.properties!==null && typeof this.props.data.properties["_ocu_offer_id"] !== "undefined" ) is_ocu_item = true;
    //console.log( this.props.data_product.tags );
    return (
      <React.Fragment>
        {(() => {
          if ( this.props.data.properties?._ocu_offer_id ) {
            return (
              <span className="price" data-ocu-price-block={this.props.data.key} data-ocu-cart-discount>${(this.props.data.final_price/100).toFixed(2)}</span>
            )
          }
          else{
            //if ( !window.__config_reactjs_cart.logon 
            if ( false
                && this.props.data_product!==null 
                && this.props.data_product.tags!==null 
                && this.props.data_product.tags.includes("Retail") 
                && !this.props.data_product.tags.includes("guest")
                && !window.__config_reactjs_cart.retail_exception_products.includes(this.props.data.handle) ) {
              return (
                <Retail data={this.props.data}/>
              )
            }
            else{
              return (
                <Normal data={this.props.data}/>
              )
            }
          }
        })()}
      </React.Fragment>
    )
      
  };
}
export default Container;